import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';

import * as medHXSubmissionManagementAPI from 'api/medHXSubmissionManagement';

const initialState = {
    list: {
        error: false,
        loaded: false,
        data: []
    }
};

const slice = createSlice({
    name: 'medHXSubmissionManagement',
    initialState,
    reducers: {
        setMedHXSubmissionManagementListError(state) {
            state.list.error = true;
            state.list.loaded = true;
        },
        setMedHXSubmissionManagementListData(state, action) {
            state.list.error = false;
            state.list.loaded = true;
            state.list.data = action.payload;
        },
        resetListState(state) {
            state.list = initialState.list;
        }
    }
});

export default slice.reducer;

export function resetListState() {
    dispatch(slice.actions.resetListState());
}

export function getMedHXSubmissionManagementList() {
    return async () => {
        try {
            const response = await medHXSubmissionManagementAPI.getMedHXSubmissionManagementList();
            dispatch(slice.actions.setMedHXSubmissionManagementListData(response.data.submissions));
        } catch (error) {
            dispatch(slice.actions.setMedHXSubmissionManagementListError(error));
        }
    };
}
